import { DEFAULT_GAME_ID, LOADER_HANDLER_TYPES, METHOD_TYPES } from 'constants/index'
import axiosInstanceService from 'network/apis/index'
import { microServices } from 'network/apis/microservice/index'

export const getAllCurrencyService = () => {
  return axiosInstanceService(METHOD_TYPES.get, 'system/get-all-currency', {}, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.table
  })
}
export const getGameSettingService = () => {
  return axiosInstanceService(METHOD_TYPES.get, 'system/get-game-settings', {}, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.table
  })
}

export const getGameDetailsService = () => {
  return axiosInstanceService(METHOD_TYPES.get, 'system/get-game-settings', {}, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.table
  })
}

export const verifyRoundHashService = (data) => {
  let endPoint = ''
  let payLoadData = {}
  
  switch (data.gameId) {
    case DEFAULT_GAME_ID.CRASH:
      endPoint = 'fast-games/crash-game/check-provable-fair'
      payLoadData = {
        roundHash: data.hashCode,
        currencyCode: data.currencyCode
      }
      break

    case DEFAULT_GAME_ID.PYRAMID_PLINKO:
      endPoint = 'fast-games/plinko-game/check-fairness'
      payLoadData = {
        clientSeed: data?.clientSeed,
        serverSeed: data?.serverSeed,
        numberOfRows: data?.numberOfRows,
        riskLevel: data?.riskLevel,
        currencyCode: data.currencyCode
      }
      break

    case DEFAULT_GAME_ID.KENO:
      endPoint = 'fast-games/keno-game/check-fairness'
      payLoadData = {
        clientSeed: data?.clientSeed,
        serverSeed: data?.serverSeed,
        riskLevel: data?.riskLevel
      }
      break

    case DEFAULT_GAME_ID.DICE:
      endPoint = 'fast-games/dice-game/check-fairness'
      payLoadData = {
        clientSeed: data?.clientSeed,
        serverSeed: data?.serverSeed
      }
      break

    case DEFAULT_GAME_ID.HILO:
      endPoint = 'fast-games/hilo-game/check-fairness'
      payLoadData = {
        clientSeed: data?.clientSeed,
        serverSeed: data?.serverSeed
      }
      break

    case DEFAULT_GAME_ID.GONGA_MINE:
      endPoint = 'fast-games/mine-game/check-provable-fair'
      payLoadData = {
        clientSeed: data?.clientSeed,
        serverSeed: data?.serverSeed,
        mineCount: data?.numberOfGongaMines
      }
      break

    case DEFAULT_GAME_ID.COIN_FLIP:
      endPoint = 'fast-games/coin-flip-game/check-fairness'
      payLoadData = {
        clientSeed: data?.clientSeed,
        serverSeed: data?.serverSeed
      }
      break

    case DEFAULT_GAME_ID.TOWER:
      endPoint = 'fast-games/tower-game/check-fairness'
      payLoadData = {
        clientSeed: data?.clientSeed,
        serverSeed: data?.serverSeed,
        gameModeType: data?.gameModeType,
        difficultyType: data?.difficultyType
      }
      break
    case DEFAULT_GAME_ID.CROSS:
      endPoint = 'fast-games/cross-game/check-fairness'
      payLoadData = {
        clientSeed: data?.clientSeed,
        serverSeed: data?.serverSeed
      }
      break

    default:
      break
  }
  return axiosInstanceService(METHOD_TYPES.post, endPoint, payLoadData, {
    server: microServices.SERVICE_URL_1
  })
}
